import React, { useContext } from "react";
import { Link } from "gatsby";
import "../assets/css/reeddi.css";
import { ContactFormContext } from "../context/contactFormContext";
import * as Animate from "react-reveal";

import LinkedInIcon from "../assets/images/icons/linkedin.svg";
import InstagramIcon from "../assets/images/icons/insta.svg";
import FacebookIcon from "../assets/images/icons/facebook.svg";
import YoutubeIcon from "../assets/images/icons/youtube.svg";
import TwitterIcon from "../assets/images/icons/twitter.svg";

import Logo from "../assets/images/reeddilogo.png";

export default function Footer() {
  const { handleOpenContact } = useContext(ContactFormContext);

  return (
    <footer className="bg-[#F5FFFB]">
      <div className=" pt-8 md:pt-16 flex flex-col  ">
        <div className="w-11/12 max-w-7xl mx-auto flex flex-col flex-wrap  sm:flex-row ">
          <div className="order-1 lg:order-1  flex flex-col mb-4 w-full lg:w-4/12">
            <Animate.Fade bottom>
              <div className="mb-4 w-20">
                <img src={Logo} alt="reeddi" />
              </div>

              <div className="flex flex-col">
                <p className="text-sm lg:text-base leading-6 lg:leading-7 text-reeddigrey mb-4 max-w-[360px]">
                  Reeddi is a climate-tech company that seeks to bridge the
                  accessibility gap through sustainable and limitless
                  innovations.
                </p>

                <div className="text-sm text-reeddigrey flex flex-col mt-4">
                  <a href="mailto:hello@reeddi.com" className="mb-4 block">
                    <span className="font-semibold">Email us:</span>{" "}
                    hello@reeddi.com{" "}
                  </a>
                </div>
              </div>
            </Animate.Fade>
          </div>

          <div className="order-3 lg:order-2 w-full lg:w-6/12 grid grid-cols-2 lg:grid-cols-3 justify-between lg:pr-5">
            <Animate.Fade bottom>
              <div className="flex flex-col mb-8 lg:mb-4 min-w-fit">
                <p className="font-semibold mb-4">Products</p>
                <div className="text-sm text-reeddigrey flex flex-col">
                  <Link to="/reeddi-capsule" className="block mb-4">
                    Reeddi Capsule
                  </Link>
                  <Link to="/reeddi-energybox" className="block mb-4">
                    Reeddi EneryBox
                  </Link>
                  <Link to="/reeddi-bigenergy" className="block mb-4">
                    Reeddi BigEnergy
                  </Link>
                  <Link
                    target={"_blank"}
                    rel="noopener noreferrer"
                    to="https://www.tempown.com"
                    className="block mb-4">
                    TempOwn
                  </Link>
                  <Link
                    target={"_blank"}
                    rel="noopener noreferrer"
                    to="https://www.usepluck.com"
                    className="block mb-4">
                    Pluck
                  </Link>
                </div>
              </div>

              <div className="mb-8 lg:mb-4 min-w-fit flex flex-col">
                <p>
                  <p className="font-semibold mb-4">The Company</p>
                </p>
                <div className="text-sm text-reeddigrey flex flex-col mb-4 ">
                  <Link to="/about" className="block mb-4">
                    About Us
                  </Link>
                  <Link
                    to="/#Contact"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpenContact(true);
                    }}
                    className="block mb-4">
                    Contact Us
                  </Link>
                  <Link to="/awards" className="block mb-4">
                    Awards & Impact
                  </Link>
                  <Link to="/faqs" className="block mb-4">
                    FAQs
                  </Link>
                </div>
              </div>

              <div className="flex flex-col mb-8 lg:mb-4 min-w-fit">
                <p>
                  <p className="font-semibold mb-4">Learn</p>
                </p>
                <div className="text-sm text-reeddigrey flex flex-col mb-4 ">
                  <Link to="/research" className="block mb-4">
                    Research
                  </Link>
                  <Link
                    to="https://medium.com/@getreeddi"
                    target={"_blank"}
                    rel="noopener noreferrer"
                    className="block mb-4">
                    Articles
                  </Link>
                  <Link to="/ambassador" className="block mb-4">
                    <span className="lg:hidden">
                      Become A Reeddi Ambassador
                    </span>
                    <span className="hidden lg:block">
                      Become A Reeddi
                      <br /> Ambassador
                    </span>
                  </Link>
                  <Link to="/rent-a-capsule" className="block mb-4">
                    Rent Our Reeddi Product
                  </Link>
                  <Link to="/pay-in-installments" className="block mb-4">
                    Pay In Installments
                  </Link>
                  <Link to="/rental-policy" className="block md:mt-0">
                    Rental Policy
                  </Link>
                </div>
              </div>
            </Animate.Fade>
          </div>

          <div className="order-2 lg:order-3 flex flex-col mb-4 w-full lg:w-2/12">
            <Animate.Fade bottom>
              <p>
                <p className="font-semibold mb-4">Contact</p>
              </p>

              <div className="flex flex-col mb-4">
                <div className="text-sm leading-6 mb-6">
                  <p className="text-black">
                    <p className="font-semibold">🇳🇬 Lagos, Nigeria.</p>
                  </p>
                  <p className="text-reeddigrey">32b Okunola Aina Street,</p>
                  <p className="text-reeddigrey">Maryland, Lagos</p>
                  <a
                    href="tel:+234 705 044 5599"
                    className="text-reeddigrey block">
                    Tel: +234 705 044 5599
                  </a>
                  <a
                    href="tel:+234 915 842 8464"
                    className="text-reeddigrey block">
                    <span className="opacity-0">Tel: </span>+234 915 842 8464
                  </a>
                </div>
                <div className="text-sm   leading-6">
                  <p className="text-black">
                    <p className="font-semibold">🇨🇦 Toronto, Canada.</p>
                  </p>
                  <p className="text-reeddigrey">
                    Schwartz Reisman Innovation Campus, 7th Floor, Suite W754
                  </p>
                  <p className="text-reeddigrey">
                    108 College St, Toronto, <br className="hidden lg:block" />
                    ON M5G 1L7
                  </p>
                  <a href="tel:+16474554327" className="text-reeddigrey block">
                    Tel: +16474554327
                  </a>
                </div>
              </div>
            </Animate.Fade>
          </div>
        </div>

        <div className="footer-bg-grdient hidden md:block mt-12">
          <div className=" w-11/12  max-w-7xl mx-auto flex-col-reverse md:flex md:flex-row  justify-between items-center center gap-x-20 py-4 lg:py-8 ">
            <Animate.Fade bottom>
              <p className="my-2 sm:my-0 text-xs sm:text-xs md:text-sm text-white">
                {new Date().getFullYear()} Reeddi. All Rights Reserved
              </p>

              <div className="flex items-center space-x-10">
                <div className="my-3  sm:my-0 flex sm:justify-between items-center gap-x-4 text-xs md:text-sm text-white">
                  <Link to="/terms-of-use">Terms of Service</Link>
                </div>

                <div className="my-3  sm:my-0 flex sm:justify-between items-center gap-x-4 text-xs md:text-sm text-white">
                  <Link to="/privacy-notice">Privacy Notice</Link>
                </div>
              </div>

              <div className="my-2 sm:my-0 flex sm:justify-between items-center gap-x-6">
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.linkedin.com/company/reeddi/mycompany/">
                  <img
                    className="w-4 md:w-6"
                    src={LinkedInIcon}
                    alt="linkedin"
                  />
                </Link>
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.instagram.com/reeddihq/">
                  <img className="w-3 md:w-6" src={InstagramIcon} alt="insta" />
                </Link>
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.facebook.com/Reeddi/">
                  <img
                    className="w-3 md:w-6"
                    src={FacebookIcon}
                    alt="facebook"
                  />
                </Link>
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.youtube.com/channel/UCdBac6w8Yo4c8r9TB74mNvg">
                  <img className="w-4 md:w-6" src={YoutubeIcon} alt="youtube" />
                </Link>
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://twitter.com/Reeddi">
                  <img className="w-4 md:w-6" src={TwitterIcon} alt="twitter" />
                </Link>
              </div>
            </Animate.Fade>
          </div>
        </div>

        <div className="footer-bg-grdient block md:hidden mt-6 md:mt-10">
          {/* mobile footer */}
          <div className="pt-12 flex flex-col-reverse md:hidden md:flex-row  justify-between items center gap-x-20 pb-2">
            <Animate.Fade bottom>
              <p className="my-2 md:my-0 text-xs md:text-sm text-center text-white">
                {new Date().getFullYear()} Reeddi. All Rights Reserved
              </p>

              <div>
                <div className="my-3  md:my-0 flex justify-center items-center gap-x-4 text-sm text-white">
                  <Link to="/terms-of-use">Terms of Service</Link>
                </div>

                <div className="my-3  md:my-0 flex justify-center items-center gap-x-4 text-sm text-white">
                  <Link to="/privacy-notice">Privacy Notice</Link>
                </div>
              </div>
            </Animate.Fade>
          </div>
          <div className="flex flex-col-reverse md:flex-row  justify-center items-center gap-x-20 py-3 pb-14">
            <Animate.Fade bottom>
              <div className="my-2 md:my-0 flex md:justify-between items-center md:gap-x-8">
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.linkedin.com/company/reeddi/mycompany/">
                  <img
                    className="w-5 md:w-auto mx-3"
                    src={LinkedInIcon}
                    alt="linkedin"
                  />
                </Link>

                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.instagram.com/reeddihq/">
                  <img
                    className="w-5 md:w-auto mx-3"
                    src={InstagramIcon}
                    alt="insta"
                  />
                </Link>
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.facebook.com/Reeddi/">
                  <img
                    className="w-5 md:w-auto mx-3"
                    src={FacebookIcon}
                    alt="facebook"
                  />
                </Link>
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://www.youtube.com/channel/UCdBac6w8Yo4c8r9TB74mNvg">
                  <img
                    className="w-5 md:w-auto mx-3"
                    src={YoutubeIcon}
                    alt="youtube"
                  />
                </Link>
                <Link
                  target={"_blank"}
                  rel="noopener noreferrer"
                  to="https://twitter.com/Reeddi">
                  <img
                    className="w-5 md:w-auto ml-1 mx-3"
                    src={TwitterIcon}
                    alt="twitter"
                  />
                </Link>
              </div>
            </Animate.Fade>
          </div>
        </div>
      </div>
    </footer>
  );
}
